<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gRGf9u/tc-custom/9781504057943.jpg?1734378431027" alt="This image is the cover for the book On Beulah Height, The Dalziel and Pascoe Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On Beulah Height, The Dalziel and Pascoe Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A New York Times Notable Book: </b><b>A girl’s disappearance unearths old crimes for the Yorkshire detectives in this “multilayered masterpiece” (<i>Publishers Weekly</i>).</b><br/>  <br/> Reginald Hill “raised the classical British mystery to new heights” when he introduced pugnacious Yorkshire Det. Inspector Andrew Dalziel and his partner, the callow Sgt. Peter Pascoe (<i>The New York Times Book Review</i>). Their chafing differences in education, manners, technique, and temperament made them “the most remarkable duo in the annals of crime fiction” (<i>Toronto Star</i>). Adapted into a long-running hit show for the BBC, the Gold Dagger Award–winning series is now available as ebooks.<br/>  <br/> It’s been fifteen years since three girls were abducted from Dendale. Just as long since the village was flooded to create a reservoir. Haunted by the cold case, Andrew Dalziel believes the truth was submerged forever. But now, with a drought, the ruins of Dendale are reemerging—along with its mysteries. And as if by a terrible twist of fate, another child has vanished from a nearby hamlet. For Dalziel to finally solve an unspeakable crime, he must once again stir the dread of a still-traumatized community—and all its secrets.<br/>  <br/> “Weaving their pain into his densely textured story of Dendale’s cursed past and haunted present, Hill creates a tragic tale of loss and regret and the persistence of grief” (<i>The New York Times Book Review</i>).<br/>  <br/> On Beulah Height <i>is the 18th book in the Dalziel and Pascoe Mysteries, but you may enjoy reading the series in any order.</i><br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Reginald Hill
      </h2>
      
      <p class="authorDescription body article">Reginald Hill was an English crime writer and fellow of the Royal Society of Literature. He won the 1995 Crime Writers&rsquo; Association Diamond Dagger for Lifetime Achievement.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4f9af46